export default {
  OneSKUPerContainer: 'skuType.OneSKUPerContainer',
  MultipleSKUPerContainer: 'skuType.MultipleSKUPerContainer'
}

export const skuTypeEnum = {
  OneSKUPerContainer: 1,
  MultipleSKUPerContainer: 2
}

export const skuTypeApiEnum = {
  [skuTypeEnum.OneSKUPerContainer]: 2,
  [skuTypeEnum.MultipleSKUPerContainer]: 3
}
